module.exports = __webpack_public_path__ + "img/logo-boost-credit.f55b3862.svg";